import React, {memo, ReactNode, useMemo} from 'react';
import {ControlModel, ControlTypeModel, ThreePhaseSet} from '../../types/control';
import upButton from '../../assets/images/icons/controls/up-button.png';
import equalButton from '../../assets/images/icons/controls/equal-button.png';
import downButton from '../../assets/images/icons/controls/down-button.png';
import {Column} from '../Column';
import {Widget} from '../Widget';
import './index.scss';
import {PhaseStatus} from './index';
import {onClickHandler} from '../../utils/onclick';

type Props = {
    control: ControlModel;
    click: (curtainStatus: PhaseStatus) => void;
    children?: ReactNode;
    controlType: ControlTypeModel<ThreePhaseSet>;
};

export const ThreePhaseControlComponent = memo(function ThreePhaseControlComponent(props: Props) {
    const {control, children, click, controlType} = props;

    const isTwoPhase = controlType.render_type === 'two_phase';

    const curtainStatus = control.current_value as PhaseStatus;

    const icon = useMemo(() => {
        if (curtainStatus === PhaseStatus.Up) {
            return controlType.image_set.up;
        }
        if (curtainStatus === PhaseStatus.Down) {
            return controlType.image_set.down;
        }
        if (curtainStatus === PhaseStatus.Stop) {
            return controlType.image_set.stop;
        }

        return null;
    }, [controlType, curtainStatus]);

    return (
        <Column min={6} max={12}>
            <Widget style={{padding: 0}}>
                <div className="position-relative">
                    <div className="curtain">
                        <img src={icon} alt="curtain"/>
                        <div className=" curtain-title">
                            <span>{control.name}</span>
                        </div>
                        <div className="curtain-buttons">
                            <div className="control-button">
                                <button {...onClickHandler(() => click(PhaseStatus.Up))}>
                                    <img src={upButton} alt="up"/>
                                </button>
                            </div>
                            {
                                renderIf(!isTwoPhase)(() => (
                                    <div className="control-button">
                                        <button {...onClickHandler(() => click(PhaseStatus.Stop))}>
                                            <img src={equalButton} alt="stop"/>
                                        </button>
                                    </div>
                                ))
                            }
                            <div className="control-button">
                                <button {...onClickHandler(() => click(PhaseStatus.Down))}>
                                    <img src={downButton} alt="down"/>
                                </button>
                            </div>
                        </div>
                    </div>
                    {children}
                </div>
            </Widget>
        </Column>
    );
});
